"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateNumber = function (value, _a) {
    var precision = _a.precision;
    if (precision) {
        var indexOfComma = String(value).indexOf('.');
        var formattedFloatingNumberAsString = String(value).substr(0, indexOfComma + precision + 1);
        return indexOfComma > -1
            ? Number.parseFloat(formattedFloatingNumberAsString)
            : Number.parseInt(value.toFixed(), 10);
    }
    return Number.parseInt(value.toFixed(), 10);
};
exports.parseTextToNumber = function (value) {
    var processedValue = value
        .replace(/(?!^[-])[^0-9.]/g, '')
        .replace(/\.+/g, '.')
        .replace(/\.+$/, '')
        .replace(/\s+/g, '');
    var result = Number(processedValue);
    if (processedValue === '' || Number.isNaN(result)) {
        return undefined;
    }
    return result;
};
exports.parseTextInputValue = function (value, params) {
    if (params === void 0) { params = { disallowDecimal: false }; }
    value = value.replace(/\.+/, '.');
    if (params.disallowDecimal && value.match(/\.+/)) {
        return { value: value, isDraft: false, isInvalid: true };
    }
    var isDraft = !!value.match(/\.0*$/) || !!value.match(/\.\d+0$/) || value === '-';
    var isInvalid = !!value.replace(/^-/, '').match(/[^.0-9]+/) || !!value.match(/\.+(?=\d+\.)/);
    return { value: value, isDraft: isInvalid ? false : isDraft, isInvalid: isInvalid };
};
exports.getCountSimbolsAfterComma = function (value) {
    var hasComma = value.includes('.');
    if (hasComma) {
        var fractionalPart = value.split('.')[1];
        return fractionalPart.length;
    }
    return 0;
};
//# sourceMappingURL=helpers.js.map